//Notification center - Delete notification
export const DELETE_NOTIFICATION = "globalNotification/DELETE_NOTIFICATION";

// Notifications - Get all notifications
export const GET_ALL_NOTIFICATIONS = "globalNotification/GET_ALL_NOTIFICATIONS";

export const UPDATE_INSIGHTS_AFTER_GLOBAL_NOTIFICATION_DELETE =
	"globalNotification/UPDATE_INSIGHTS_AFTER_GLOBAL_NOTIFICATION_DELETE";

export const NOTIFICATION_SUBITEM_DELETE =
	"globalNotification/NOTIFICATION_SUBITEM_DELETE";

export const FETCH_NOTIFICATION_DETAILS_GLOBAL =
	"notification-center/FETCH_NOTIFICATION_DETAILS_GLOBAL";
export const NOTIFICATION_DRILL_DOWN =
	"notification-center/NOTIFICATION_DRILL_DOWN";
export const NOTIFICATION_DRILL_UP =
	"notification-center/NOTIFICATION_DRILL_UP";
export const FETCH_NOTIFICATION_SUMMARY_DETAILS =
	"notification-center/FETCH_NOTIFICATION_SUMMARY_DETAILS";
export const NOTIFICATION_FETCH_DETAIL_TOTAL_TILL_DATE =
	"notification-center/NOTIFICATION_FETCH_DETAIL_TOTAL_TILL_DATE";

export type Action =
	| { type: DELETE_NOTIFICATION, data: Object }
	| { type: GET_ALL_NOTIFICATIONS }
	| { type: UPDATE_INSIGHTS_AFTER_GLOBAL_NOTIFICATION_DELETE }
	| { type: NOTIFICATION_SUBITEM_DELETE, data: Object }
	| { type: FETCH_NOTIFICATION_DETAILS_GLOBAL, data: Object }
	| { type: NOTIFICATION_DRILL_DOWN }
	| { type: NOTIFICATION_DRILL_UP }
	| { type: FETCH_NOTIFICATION_SUMMARY_DETAILS, data: Object }
	| { type: NOTIFICATION_FETCH_DETAIL_TOTAL_TILL_DATE, data: Object };




// WEBPACK FOOTER //
// ./src/features/common/GlobalNotification/actions/action-types.js